import { useEffect } from "react";
import Lenis from "lenis";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { MarqueeRibbon } from "@/components/MarqueeRibbon";
import { Manifesto } from "@/components/Manifesto";
import { Services } from "@/components/Services";
import { Process } from "@/components/Process";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

export default function Home() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <main data-testid="home-page">
      <Nav />
      <Hero />
      <MarqueeRibbon />
      <Manifesto />
      <Services />
      <Process />
      <Contact />
      <Footer />
    </main>
  );
}
